import { base } from './';
import { FeedbackUpdateType } from 'types';

const PATH = '/event-feedback';

const get = (id: string) => base.get(`${PATH}/${id}`);

const post = ({ id, ...data }: FeedbackUpdateType) =>
  base.post(`${PATH}/${id}`, data);

const patch = ({ id, ...data }: FeedbackUpdateType) =>
  base.patch(`${PATH}/${id}`, data);

export { get, post, patch };
